import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { HourlyData } from "@/hooks/admin/attendance";

interface HourlyChartProps {
  data: HourlyData[];
}

export const HourlyChart = ({ data }: HourlyChartProps) => {
  const hasData = data.some(d => d.count > 0);
  
  if (!hasData) {
    return (
      <div className="h-[150px] sm:h-[200px] flex items-center justify-center text-muted-foreground text-sm">
        Sin ingresos en este período
      </div>
    );
  }

  const maxCount = Math.max(...data.map(d => d.count), 1);

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const { hour, count } = payload[0].payload;
      return (
        <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-lg">
          <p className="text-sm font-medium text-foreground">
            {hour}:00 - {hour + 1}:00
          </p>
          <p className="text-sm text-muted-foreground">
            {count} {count === 1 ? "ingreso" : "ingresos"}
          </p>
        </div>
      );
    }
    return null;
  };

  // Filter to show only even hours for cleaner display
  const tickFormatter = (hour: number) => `${hour}`;
  
  return (
    <div className="h-[150px] sm:h-[200px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <XAxis
            dataKey="hour"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
            tickFormatter={tickFormatter}
            interval={1}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
            allowDecimals={false}
            width={30}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "hsl(var(--muted) / 0.3)" }} />
          <Bar dataKey="count" radius={[4, 4, 0, 0]} maxBarSize={30}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.count > 0 ? "hsl(var(--primary))" : "hsl(var(--muted))"}
                fillOpacity={0.3 + (entry.count / maxCount) * 0.7}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
